/**
=========================================================
* Soft UI Dashboard PRO React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-material-ui
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { forwardRef } from "react";

// Core
import PropTypes from "prop-types";

// Components
import BoxV1 from "components/Atoms/Box/BoxV1";
import TypographyV1 from "components/Atoms/Typography/TypographyV1";

const BadgeDot = forwardRef(({ color, size, badgeContent, gradient, font, ...rest }, ref) => {
  let finalSize;
  let fontSize;
  let padding;

  if (size === "small") {
    finalSize = "0.375rem";
    fontSize = "caption";
    padding = "0.45em 0.775em";
  } else if (size === "large") {
    finalSize = "0.625rem";
    fontSize = "body2";
    padding = "0.85em 1.375em";
  } else if (size === "medium") {
    finalSize = "0.5rem";
    fontSize = "button";
    padding = "0.65em 1emm";
  } else {
    finalSize = "0.5rem";
    fontSize = "caption";
    padding = "0.45em 0.775em";
  }

  return (
    <BoxV1 ref={ref} display="flex" alignItems="center" p={padding} {...rest}>
      <BoxV1
        component="i"
        display="inline-block"
        width={finalSize}
        height={finalSize}
        borderRadius="50%"
        backgroundColor={color}
        backgroundGradient={gradient}
        mr={1}
      />
      <TypographyV1
        variant={fontSize}
        fontWeight={font.weight ? font.weight : "regular"}
        textColor={font.color ? font.color : "dark"}
        customClass="line-height-0"
      >
        {badgeContent}
      </TypographyV1>
    </BoxV1>
  );
});

// Setting default values for the props of Badge
BadgeDot.defaultProps = {
  color: "info",
  size: "default",
  gradient: false,
  font: {},
};

// Typechecking props of the Badge
BadgeDot.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "light",
    "dark",
  ]),
  size: PropTypes.oneOf(["default", "small", "medium", "large"]),
  badgeContent: PropTypes.string.isRequired,
  font: PropTypes.shape({
    color: PropTypes.string,
    weight: PropTypes.string,
  }),
  gradient: PropTypes.bool,
};

export default BadgeDot;
